import { StoreActions } from '../actions';

export const privacyPolicyReducer = (state = {}, action) => {
  switch (action.type) {
    case StoreActions.GET_PRIVACY_POLICY:
      return action.payload;
    default:
      return state;
  }
};
